
import React from 'react';
import Hero from '@/components/Hero';
import { ExternalLink, Newspaper } from 'lucide-react';
import { Link } from 'react-router-dom';

type NewsArticle = {
  title: string;
  publication: string;
  date: string;
  description: string;
  link: string;
  image: string;
  quote?: string;
};

const InTheNews = () => {
  const newsArticles: NewsArticle[] = [
    {
      title: "Let me tell you...these weird walking tours are the best way to explore NYC",
      publication: "Time Out New York",
      date: "May 2025",
      description: "Time Out New York features Cats About Town Tours in their roundup of unique and unusual walking tours in NYC that offer visitors and locals alike a fresh perspective on the city.",
      link: "https://www.timeout.com/newyork/news/let-me-tell-youthese-weird-walking-tours-are-the-best-way-to-explore-nyc-051525",
      image: "https://www.purabrasa.com/wp-content/uploads/2024/07/time-out-logo.jpg",
      quote: "Cat lovers can enjoy a pawsitively purrfect stroll through Brooklyn Heights and the Financial District tracing the tales of NYC's most famous feline residents..."
    },
    {
      title: "This NYC Walking Tour Is Perfect For Cat Lovers",
      publication: "Fodors",
      date: "April 2024",
      description: "Explore feline history on a walking tour of New York City guided by a local cat historian. The tour takes you through historic neighborhoods to uncover fascinating stories of cats that have left their paw prints on the city's past.",
      link: "https://www.fodors.com/world/north-america/usa/new-york/new-york-city/experiences/news/this-nyc-walking-tour-is-perfect-for-cat-lovers",
      image: "https://cdn.b12.io/client_media/p2VnEghv/c1345f98-90c7-11ef-9031-0242ac110002-png-regular_image.png"
    },
    {
      title: "The Ultimate Tour For New York Cat Enthusiasts: Cats About Town Walking Tour",
      publication: "AM New York",
      date: "March 2024",
      description: "New York City tour shines a spotlight on the role cats played in the city's development. From feline shipmates to bodega cats, this tour shares the stories of New York's whiskered residents through the centuries.",
      link: "https://www.amny.com/entertainment/things-to-do/ultimate-tour-new-york-cat-enthusiasts-cats-about-town-walking-tour/",
      image: "https://cdn.b12.io/client_media/p2VnEghv/b19c23fc-90e7-11ef-bd5c-0242ac110002-png-regular_image.png"
    },
    {
      title: "New NYC walking tour aims to capture cat lovers and history buffs",
      publication: "NBC New York",
      date: "February 2024",
      description: "A unique walking tour that combines New York City history with stories of its most famous feline residents is drawing in cat enthusiasts and history lovers alike, offering a fresh perspective on familiar landmarks.",
      link: "https://www.nbcnewyork.com/news/local/new-nyc-walking-tour-aims-to-capture-cat-lovers-and-history-buffs/5721049/",
      image: "https://cdn.b12.io/client_media/p2VnEghv/84b8d216-746f-11ef-9907-0242ac110002-png-regular_image.png",
      quote: "One attendee on the first tour described the personal cat stories as an 'emotional roller coaster.'"
    },
    {
      title: "Cat walking tour takes tourists around Brooklyn",
      publication: "The Guardian",
      date: "September 2023",
      description: "A Brooklyn Heights walking tour focuses on the neighborhood's feline history, from shipyard cats to the pets of famous authors. The tour combines the charm of historic architecture with tales of remarkable cats throughout New York's past.",
      link: "https://www.theguardian.com/us-news/2024/sep/16/cat-walking-tour-brooklyn",
      image: "https://cdn.b12.io/client_media/p2VnEghv/49ab3a42-6ebb-11ef-a2a3-0242ac110002-svg-regular_image.png"
    },
    {
      title: "Bodega Cats of New York Celebrated in New History Tours",
      publication: "NPR",
      date: "April 2024",
      description: "A local historian offers walking tours celebrating New York City's rich feline history, from working cats on ships and in factories to the iconic bodega cats that have become beloved fixtures in neighborhood stores.",
      link: "https://www.npr.org/2025/04/24/nx-s1-5339780/bodega-cats",
      image: "https://1000logos.net/wp-content/uploads/2021/05/NPR-logo.png"
    },
    {
      title: "Bodega Cats of New York: Local Historian Offers Cat-Centric Tours of New York City",
      publication: "People Magazine",
      date: "May 2024",
      description: "Peggy Gavan, author of 'The Cat Men of Gotham,' leads walking tours through historic New York neighborhoods, sharing stories of famous felines and their human companions throughout the city's history.",
      link: "https://people.com/bodega-cats-of-new-york-local-historian-offer-cat-centric-tours-of-new-york-city-exclusive-8762208",
      image: "https://cdn.b12.io/client_media/p2VnEghv/02f60512-c48a-11ef-8de4-0242ac110002-png-regular_image.png",
      quote: "We started doing tours in August, and they've been selling out. We've gotten a lot of publicity. No one else is doing this."
    },
    {
      title: "Nueva York contada por gatos",
      publication: "EFE",
      date: "September 2023",
      description: "Una historiadora ofrece recorridos a pie por Nueva York centrados en la historia felina de la ciudad, desde los gatos marineros que llegaron en barcos hasta los famosos gatos de bodega que ahora son íconos culturales.",
      link: "https://efe.com/mundo/2024-09-05/nueva-york-contada-por-gatos/",
      image: "https://upload.wikimedia.org/wikipedia/commons/8/84/EFE_logo.svg"
    },
    {
      title: "From the Halloween Parade to Cat Lady Nights: Cats are having a moment in NYC",
      publication: "Time Out New York",
      date: "October 2023",
      description: "Cats About Town Tours is bringing New York's feline history to life with walking tours through Brooklyn Heights, the Financial District, and the Lower East Side, highlighting the significant role cats have played in the city's development.",
      link: "https://www.timeout.com/newyork/news/from-the-halloween-parade-to-cat-lady-nights-cats-are-having-a-moment-in-nyc-103024",
      image: "https://www.purabrasa.com/wp-content/uploads/2024/07/time-out-logo.jpg",
      quote: "A walking tour called Cats About Town launched as the self-described first walking tour for cat lovers… led by cat historian Peggy Gavan."
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section - Updated with new image */}
      <Hero 
        title="In the News" 
        subtitle="Press coverage and media mentions of Cats About Town Tours"
        backgroundImage="/lovable-uploads/826f948f-0253-4767-b148-40f8ebd43a17.png"
        height="medium"
        imageStyle="darken"
      />
      
      {/* News Articles Section */}
      <section className="py-20 bg-[#FAF2E8] relative">
        <div className="absolute inset-0 paper-texture"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="flex items-center justify-center mb-10">
              <div className="w-12 h-[1px] bg-[#800020]"></div>
              <span className="px-4 text-[#800020] font-cormorant italic">Media Coverage</span>
              <div className="w-12 h-[1px] bg-[#800020]"></div>
            </div>
            
            <div className="grid gap-8 md:gap-10">
              {newsArticles.map((article, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-lg shadow-elegant overflow-hidden border border-[#C58B65]/20 hover:border-[#C58B65]/60 transition-all duration-300 hover:shadow-premium"
                >
                  <div className="p-6 md:p-8 flex flex-col md:flex-row gap-8">
                    <div className="flex-shrink-0 flex items-center justify-center md:w-1/4">
                      <img 
                        src={article.image} 
                        alt={article.publication} 
                        className="max-h-20 object-contain mx-auto"
                        loading="lazy"
                      />
                    </div>
                    
                    <div className="md:w-3/4">
                      <div className="flex flex-wrap items-start justify-between gap-2">
                        <span className="text-sm text-[#800020] font-medium">{article.date}</span>
                        <span className="text-sm text-[#3E2C2F]/70 font-medium">{article.publication}</span>
                      </div>
                      
                      <h3 className="text-xl md:text-2xl font-montserrat font-bold mt-2 text-[#3E2C2F]">
                        {article.title}
                      </h3>
                      
                      <p className="mt-3 text-[#3E2C2F]/80 font-montserrat">
                        {article.description}
                      </p>
                      
                      {article.quote && (
                        <div className="mt-4 p-3 bg-[#F5F5DC] border-l-4 border-[#8B4E2E] italic text-[#3E2C2F]/90">
                          "{article.quote}" – {article.publication}
                        </div>
                      )}
                      
                      <div className="mt-6">
                        <a 
                          href={article.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-[#800020] hover:text-[#C58B65] transition-colors font-semibold"
                        >
                          Read Article <ExternalLink size={16} className="ml-2" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Press Kit CTA */}
            <div className="mt-16 bg-white rounded-lg shadow-elegant p-8 text-center border border-[#C58B65]/20">
              <Newspaper size={36} className="mx-auto text-[#800020] mb-4" />
              <h3 className="text-2xl font-montserrat font-bold mb-4 text-[#3E2C2F]">Media Inquiries</h3>
              <p className="mb-6 text-[#3E2C2F]/80 max-w-2xl mx-auto">
                Are you a journalist or content creator interested in featuring Cats About Town Tours? 
                We welcome media inquiries and are happy to provide additional information, interviews, or assets.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link to="/press-kit" className="btn-accent">
                  View Press Kit
                </Link>
                <Link to="/contact" className="btn-gold">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InTheNews;
